import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import {
  client,
  optimismClient,
  polygonClient,
  uniclient,
  uniclientOptimism,
  uniclientPolygon,
  blockClient,
  blockClientOptimism,
  blockClientPolygon,
  gaugeClientMainnet,
  gaugeClientPolygon,
} from "../apollo/client";

// get the apollo client related to the active network
export function useDataClient(chainId: number): ApolloClient<NormalizedCacheObject> {
  switch (chainId) {
    case 1:
      return client
    case 10:
      return optimismClient
    case 137:
      return polygonClient
    default:
      return client
  }
}

export function useUniswapClient(chainId: number): ApolloClient<NormalizedCacheObject> {
  switch (chainId) {
    case 1:
      return uniclient
    case 10:
      return uniclientOptimism
    case 137:
      return uniclientPolygon
    default:
      return uniclient
  }
}

// get the apollo client related to the active network for fetching blocks
export function useBlockClient(chainId: number): ApolloClient<NormalizedCacheObject> {
  switch (chainId) {
    case 1:
      return blockClient
    case 10:
      return blockClientOptimism
    case 137:
      return blockClientPolygon
    default:
      return blockClient
  }
}

export function useGaugeClient(
  chainId: number
): ApolloClient<NormalizedCacheObject> {
  switch (chainId) {
    case 1:
      return gaugeClientMainnet;
    case 137:
      return gaugeClientPolygon;
    default:
      return gaugeClientMainnet;
  }
}

// Get all required subgraph clients
export function useClients(chainId: number): {
  dataClient: ApolloClient<NormalizedCacheObject>;
  uniClient: ApolloClient<NormalizedCacheObject>;
  blockClient: ApolloClient<NormalizedCacheObject>;
  gaugeClient: ApolloClient<NormalizedCacheObject>;
} {
  const dataClient = useDataClient(chainId);
  const uniClient = useUniswapClient(chainId);
  const blockClient = useBlockClient(chainId);
  const gaugeClient = useGaugeClient(chainId);
  return { dataClient, uniClient, blockClient, gaugeClient }
}
